import React from "react";

export const Input = React.forwardRef(({ pre, post, label, error, className, disabled = false, ...inputRest }, ref) => {
    return (
        <div className='relative flex flex-col w-full mt-2 mb-2'>
            {label && <div className="bg-white ">
                <span className="relative text-xs tracking-wide text-gray-500 uppercase">{label}</span>
            </div>}
            <div className={`py-2 px-2 text-sm  w-full flex flex-row justify-center items-center border border-solid border-gray-300 rounded focus:outline-none focus:border-gray-600 
            ${disabled ? 'bg-gray-200' : ''}`}>
                {pre}
                <input disabled={disabled} autoComplete="off" 
                    className={`flex-1 w-full outline-none ${className} `}
                    {...inputRest}
                    ref={ref}
                />
                {post}
            </div>
            {error?.message && <div className='text-xs text-pink-800'>{error?.message}</div>}
        </div>
    );
});

export default Input;
